/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import { detectingMobile } from '../detectingMobileDevice';

/*
 *  @description Component
 *  Gestion des select rendu différent pour les mobiles,
 *  afin d'optimiser l'intégration
 */

const RenderSelectField = ({
  datas,
  input,
  label,
  meta,
  style,
  id,
  disabled,
  fullWidth,
  displayErrorBeforeSubmit
}) => {
  let displayError;
  if (displayErrorBeforeSubmit) {
    displayError = !!meta.error;
  } else {
    displayError = !!(meta.submitFailed && meta.error);
  }
  if (detectingMobile) {
    return (
      <FormControl
        error={displayError}
        style={style}
        disabled={disabled}
        fullWidth={fullWidth}
      >
        <InputLabel>{label}</InputLabel>
        <NativeSelect {...input} id={id}>
          <option value="" />
          {datas.map((data, index) => (
            <option key={data.id ? data.id : index} value={data.value}>
              {data.name ? data.name : data.label}
            </option>
          ))}
        </NativeSelect>
        <div>
          {displayError ? <FormHelperText>{meta.error}</FormHelperText> : null}
        </div>
      </FormControl>
    );
  }
  return (
    <FormControl
      error={displayError}
      style={style}
      disabled={disabled}
      fullWidth={fullWidth}
    >
      <InputLabel>{label}</InputLabel>
      <Select {...input} data-cy={id} error={displayError}>
        {datas.map((data, index) => (
          <MenuItem
            key={data.id ? data.id : index}
            value={data.value}
            data-cy={`${id}-${data.id}`}
          >
            {data.name ? data.name : data.label}
          </MenuItem>
        ))}
      </Select>
      {displayError ? <FormHelperText>{meta.error}</FormHelperText> : null}
    </FormControl>
  );
};

RenderSelectField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  datas: PropTypes.array,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  style: PropTypes.object,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  displayErrorBeforeSubmit: PropTypes.bool
};

export default RenderSelectField;
